import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'interval', standalone: true })
export class IntervalPipe implements PipeTransform {
  transform(value: number): string {
    const minutes = Math.floor(value / 60);
    const seconds = value % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }
}
